<template>
  <PagedCategory v-bind="$attrs" />
</template>

<script>
import PagedCategory from './page/_page'
export default {
  components: {
    PagedCategory,
  },
}
</script>
